import axios from "axios";
import {
  //cacheAdapterEnhancer,
  throttleAdapterEnhancer
} from "axios-extensions";

const AuthHeader = () => {
  // return authorization header with basic auth credentials
  const token = localStorage.getItem("token");

  if (token) {
    return "Bearer " + token;
  } else {
    return;
  }
};
const baseUrl = "http://localhost:4001/api";
const http = axios.create({
  baseURL: "https://api-rest-socket-tesis.herokuapp.com/api",
  // baseURL:baseUrl,
  headers: { "Cache-Control": "no-cache", Authorization: AuthHeader() },
  adapter: throttleAdapterEnhancer(axios.defaults.adapter, {
    threshold: 2 * 1000
  })
});

export default http;
